import * as React from 'react';
import './Loader.scss';
import { SettingOutlined } from '@ant-design/icons/lib';

export const Loader = ({ style }: any) => (
    <div className="loader" style={style}>
        <SettingOutlined spin />
    </div>
);
